/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'Instructor'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('instructor'); // main translation loaded for instructor
		$translatePartialLoader.addPart('subscriptionstatus'); // one to many reference from main entity
		$translatePartialLoader.addPart('relation'); // one to many reference from main entity
		$translatePartialLoader.addPart('relationtype'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('relationsource'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('gender'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('clientof'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('langkey'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('event'); // one to many reference from main entity
		$translatePartialLoader.addPart('article'); // one to many reference from main entity
		$translatePartialLoader.addPart('subscription'); // one to many reference from main entity
		$translatePartialLoader.addPart('subscriptiontype'); // one to one or many to one reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/instructor/instructor-dialog.html';

		return {
			/* new state for entity instructor */
			/* to access: ui-ref="instructor.list.new" */
			/* url: hostname/instructor/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase
				referredBy: null, // will be populated once this new state is triggered from another new state with + button
				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				'HistoryService',
				function($stateParams, $state, $uibModal, $rootScope, HistoryService) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'InstructorDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'InstructorFactory',
									'NewInstructorFactory',
									function(InstructorFactory, NewInstructorFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new Instructor
										// - resuming the creation of a new new Instructor AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return InstructorFactory.get({ id: $stateParams.instructorId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewInstructorFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function(result) {
							// process success result, if necessary
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// set relation as reference in the referredBy data model
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;
							}
						})
						.catch(function(closeReason) {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// reset relation in referred data model object
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = null;
							}
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
							}

							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for instructor new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for instructor edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('instructor', {
		/* abstract state for entity instructor */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/instructor',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'Instructors',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('instructor.list', {
		/* list state for entity instructor */
		/* to access: ui-ref="instructor.list" */
		/* url: hostname/instructor/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/instructor/instructors.html',
				controller: 'InstructorController',
			},
		},
	});

	$stateProvider.state('instructor.detail', {
		/* detail state for entity instructor */
		/* to access: ui-sref="instructor.detail" */
		/* url: hostname/instructor/detail/:instructorId */
		url: '/detail/:instructorId',
		views: {
			'content@': {
				templateUrl: 'app/entities/instructor/instructor-detail.html',
				controller: 'InstructorDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'InstructorFactory',
				function($stateParams, InstructorFactory) {
					return InstructorFactory.get({ id: $stateParams.instructorId });
				},
			],
		},
	});

	/* url: http://<hostname>/instructor/list/new */
	$stateProvider.state('instructor.list.new', getNewState());
	/* url: http://<hostname>/instructor/list/:instructorId/edit */
	$stateProvider.state('instructor.list.edit', getEditState('/:instructorId/edit'));
	/* url: http://<hostname>/instructor/detail/:instructorId/edit */
	$stateProvider.state('instructor.detail.edit', getEditState('/edit'));
	// Relation.instructor with multiplicity 0..n points to Instructor
	/* url: http://<hostname>/relation/detail/:relationId/instructor/new */
	$stateProvider.state('relation.detail.newInstructor', getNewState('/instructor/new'));
	/* url: http://<hostname>/relation/detail/:relationId/instructor/:instructorId/edit */
	$stateProvider.state('relation.detail.editInstructor', getEditState('/instructor/:instructorId/edit'));
	// Rare case of mixing non-dto's on a dto screen
	/* url: http://<hostname>/user-relation/detail/:relationId/instructor/new */
	$stateProvider.state('user-relation.detail.newInstructor', getNewState('/instructor/new'));
	/* url: http://<hostname>/user-relation/detail/:relationId/instructor/:instructorId/edit */
	$stateProvider.state('user-relation.detail.editInstructor', getEditState('/instructor/:instructorId/edit'));
	// Event.instructor with multiplicity 0..n points to Instructor
	/* url: http://<hostname>/event/detail/:eventId/instructor/new */
	$stateProvider.state('event.detail.newInstructor', getNewState('/instructor/new'));
	/* url: http://<hostname>/event/detail/:eventId/instructor/:instructorId/edit */
	$stateProvider.state('event.detail.editInstructor', getEditState('/instructor/:instructorId/edit'));

	$stateProvider.state('subscription.list.newInstructor', getNewState('/instructor/new'));

	$stateProvider.state('event.detail.booking.newInstructor', getNewState('/instructor/new'));
	$stateProvider.state('event.detail.subscriptions.newInstructor', getNewState('/instructor/new'));
	$stateProvider.state('event.detail.subscriptions.editInstructor', getEditState('/instructor/:instructorId/edit'));
});
